import { render, staticRenderFns } from "./ForgotPasswordFloat.vue?vue&type=template&id=27b1949c&scoped=true"
import script from "./ForgotPasswordFloat.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordFloat.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordFloat.vue?vue&type=style&index=0&id=27b1949c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b1949c",
  null
  
)

export default component.exports